/**
 * Unassigned Ticket Model
 *
 * Interfaces for unassigned support tickets in the admin portal.
 * Unassigned tickets are those where the Zoho Desk webhook could not
 * automatically match a ticket to an organization.
 *
 * @see agent-os/specs/2026-01-23-unassigned-tickets/spec.md
 */

/**
 * Represents a support ticket that has not been assigned to an organization.
 */
export interface UnassignedTicket {
  id: string;
  ticketNumber: string;
  subject: string;
  status: string;
  priority: string;
  contactEmail?: string;
  contactPhone?: string;
  contactName?: string;
  createdAt: string;
  updatedAt: string;
}

/**
 * Paginated response for the unassigned tickets list endpoint.
 */
export interface UnassignedTicketListResponse {
  tickets: UnassignedTicket[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

/**
 * Request body for assigning a ticket to an organization.
 */
export interface AssignTicketRequest {
  organizationId: string;
  profileId?: string;
}
